import { Link } from 'react-router-dom';
import { mockCategories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="mb-8 md:mb-10">
          <p className="text-xs md:text-sm font-medium text-secondary-700 tracking-widest mb-2">EXPLORE / 分区</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">按你关心的方向围观</h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
            六个常驻分区覆盖日常讨论的主要场景，选择分区即可只看该方向的讨论热度与主流看法。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {mockCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?cat=${cat.id}`}
              className="group flex items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200/80 rounded-lg hover:border-secondary-400 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{cat.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count} 个话题</span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}